let currentPopup = null;
let lastPopupTime = 0;

/**
 * Opens an OAuth popup window with proper positioning and duplicate prevention
 * @param {string} url - The URL to open in the popup
 * @param {string} source - Source identifier (e.g., 'manage-accounts', 'create-campaign')
 * @returns {Window|null} - The popup window object or null if blocked/prevented
 */
export const openAuthPopup = (url, source = 'unknown') => {
  // Prevent rapid reopening (debounce)
  const now = Date.now();
  if (now - lastPopupTime < 1000) {
    console.log('🚫 Preventing rapid popup reopening');
    return null;
  }
  lastPopupTime = now;

  // Close any existing popup
  if (currentPopup && !currentPopup.closed) {
    console.log('🔄 Closing existing popup');
    currentPopup.close();
  }

  // Calculate centered position
  const width = 500;
  const height = 600;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  // Add timestamp and source to prevent caching
  const uniqueUrl = `${url}${url.includes('?') ? '&' : '?'}_=${now}&source=${source}`;
  
  console.log(`🔗 Opening OAuth popup from ${source}...`);
  currentPopup = window.open(
    uniqueUrl,
    `gmail-auth-popup-${now}`,
    `width=${width},height=${height},left=${left},top=${top},noopener,noreferrer`
  );

  if (!currentPopup) {
    console.log('❌ Popup blocked by browser');
    return null;
  }

  // Monitor popup closure
  const checkClosed = setInterval(() => {
    if (currentPopup.closed) {
      console.log('🔒 Popup closed by user');
      clearInterval(checkClosed);
      currentPopup = null;
    }
  }, 1000);

  return currentPopup;
};

/**
 * Closes the current popup if it exists
 */
export const closeCurrentPopup = () => {
  if (currentPopup && !currentPopup.closed) {
    console.log('🔒 Closing popup programmatically');
    currentPopup.close();
  }
  currentPopup = null;
};
